import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  USER_GET_PAYMENT_METHOD_BEGIN,
  USER_GET_PAYMENT_METHOD_SUCCESS,
  USER_GET_PAYMENT_METHOD_FAILURE,
  USER_GET_PAYMENT_METHOD_DISMISS_ERROR,
} from './constants';
import { createAxiosConfigWithAuth } from '../../../common/apiHelpers';
import axios from 'axios';
import config from '../../../common/config';

export function getPaymentMethod(args = {}) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: USER_GET_PAYMENT_METHOD_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${config.apiRootUrl}/subscriptions/get-method-payments`,
        createAxiosConfigWithAuth(getState()),
      );

      doRequest.then(
        (res) => {
          dispatch({
            type: USER_GET_PAYMENT_METHOD_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: USER_GET_PAYMENT_METHOD_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetPaymentMethodError() {
  return {
    type: USER_GET_PAYMENT_METHOD_DISMISS_ERROR,
  };
}

export function useGetPaymentMethod() {
  const dispatch = useDispatch();

  const { getPaymentMethodPending, getPaymentMethodError } = useSelector(
    (state) => ({
      getPaymentMethodPending: state.user.getPaymentMethodPending,
      getPaymentMethodError: state.user.getPaymentMethodError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(getPaymentMethod(...args));
    },
    [dispatch],
  );

  const boundDismissError = useCallback(() => {
    return dispatch(dismissGetPaymentMethodError());
  }, [dispatch]);

  return {
    getPaymentMethod: boundAction,
    getPaymentMethodPending,
    getPaymentMethodError,
    dismissGetPaymentMethodError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USER_GET_PAYMENT_METHOD_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getPaymentMethodPending: true,
        getPaymentMethodError: null,
      };

    case USER_GET_PAYMENT_METHOD_SUCCESS:
      // The request is success
      return {
        ...state,
        getPaymentMethodPending: false,
        getPaymentMethodError: null,
      };

    case USER_GET_PAYMENT_METHOD_FAILURE:
      // The request is failed
      return {
        ...state,
        getPaymentMethodPending: false,
        getPaymentMethodError: action.data.error,
      };

    case USER_GET_PAYMENT_METHOD_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getPaymentMethodError: null,
      };

    default:
      return state;
  }
}
